import * as React from "react";
import TopBar from "./Ops.UserMessaging.UserMessageDetailTopBar";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import { match } from "react-router-dom";
import Page from "../../UserMessaging/UserMessagePageContainer";
import Info from "../../UserMessaging/UserMessageSummaryInfoContainer";
import ApproveModal from "../../UserMessaging/UserMessageApproveModal";
import ExpireModal from "../../UserMessaging/UserMessageExpireModal";
import ExtendExpiryModal from "../../UserMessaging/UserMessageExtendExpiryModal";
import DuplicateModal from "../../UserMessaging/UserMessageDuplicateModal";
import Button from "@material-ui/core/Button";
import {
  UserMessage,
  UserMessagePage
} from "../../UserMessaging/userMessageTypes";
import { groupAuth } from "app/utils/authGroups";
import handleMutationError from "app/utils/handleMutationError";
import { dateIsInFuture } from "app/utils/filters";

type Props = {
  match: match<{ id: string }>;
  data: any;
  bumpUserMessageVersion: any;
};

type State = {
  messageDuplicating: UserMessage | null;
  messageApproving: UserMessage | null;
  messageExpiring: UserMessage | null;
  messageExtending: UserMessage | null;
};

const pageMargin = 20;

const pageComparator = function(
  page1: UserMessagePage,
  page2: UserMessagePage
) {
  return page1.id - page2.id;
};

const getPageWidthPercentage = function(pageCount: number): number {
  const percentage = 100 / pageCount;
  if (percentage > 33) {
    return 33;
  }
  return percentage;
};

class Summary extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      messageApproving: null,
      messageExpiring: null,
      messageExtending: null,
      messageDuplicating: null
    };
  }

  onCloseModal = (options = { refetchData: false }) => {
    this.setState({
      messageApproving: null,
      messageExpiring: null,
      messageExtending: null,
      messageDuplicating: null
    });
    if (options.refetchData) {
      this.props.data.refetch();
    }
  };

  onMessageDuplicationComplete = (userMessageId) =>{
    window.location.href = `/snapscan/ops/user_messaging/${userMessageId}/summary`;
 }

  onBumpVersion = (): void => {
    if (!groupAuth.hasAccessGroup(["Ops/UserMessaging"])) {
      alert("You do not have permission to bump version");
      return;
    }
    this.props
      .bumpUserMessageVersion({
        variables: {
          id: this.props.match.params.id
        }
      })
      .then(() => {
        this.props.data.refetch();
      })
      .catch(error => {
        handleMutationError(error);
      });
  };

  onOpenDuplicateModal(message: UserMessage) {
    if (!groupAuth.hasAccessGroup(["Ops/UserMessaging"])) {
      alert("You do not have permission to duplcate this user message");
      return;
    }
    this.setState({ messageDuplicating: message });
  }

  onOpenApproveModal(message: UserMessage) {
    if (!groupAuth.hasAccessGroup(["Ops/UserMessaging"])) {
      alert("You do not have permission to approve");
      return;
    }
    this.setState({ messageApproving: message });
  }

  onOpenExpireModal(message: UserMessage) {
    if (!groupAuth.hasAccessGroup(["Ops/UserMessaging"])) {
      alert("You do not have permission to expire");
      return;
    }
    this.setState({ messageExpiring: message });
  }

  onOpenExtendExpiryModal(message: UserMessage) {
    if (!groupAuth.hasAccessGroup(["Ops/UserMessaging"])) {
      alert("You do not have permission to extend a user message expiry");
      return;
    }
    this.setState({ messageExtending: message });
  }

  render() {
    const message: UserMessage | null =
      this.props.data &&
      this.props.data.user_messages &&
      this.props.data.user_messages.length === 1
        ? this.props.data.user_messages[0]
        : null;
    const pages: Array<UserMessagePage> = message
      ? (message.user_message_pages || []).concat()
      : [];
    const pageWidth = getPageWidthPercentage(pages.length);
    return (
      <div>
        <TopBar
          userMessageId={this.props.match.params.id}
          showEdit={message ? message.user_targeting_type === "draft" : true}
        />
        <section className="padded scrollable">
          {message ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "30px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  borderBottom: "1px solid #aaa",
                  alignItems: "flex-end"
                }}
              >
                <h1 style={{ margin: 0 }}>Message Info</h1>
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  borderBottom: "1px solid #aaa",
                  alignItems: "flex-end"
                }}>
                  <Button
                      color="secondary"
                      onClick={() => this.onOpenDuplicateModal(message)}
                    >
                      Duplicate
                    </Button>
                  { message.user_targeting_type === "draft" ? (
                    <Button
                      color="primary"
                      onClick={() => this.onOpenApproveModal(message)}
                    >
                      Approve
                    </Button>
                  ) : (
                    <div>
                      <Button
                        color="secondary"
                        onClick={() => this.onOpenExtendExpiryModal(message)}
                      >
                        {dateIsInFuture(message.expires_at) ? "Extend" : "Resume"}
                      </Button>
                      <Button
                        color="primary"
                        disabled={!dateIsInFuture(message.expires_at)}
                        onClick={() => this.onOpenExpireModal(message)}
                      >
                        {dateIsInFuture(message.expires_at)
                          ? "Expire"
                          : "Expired"}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
              <Info
                editMode={false}
                message={message}
                onBumpVersion={this.onBumpVersion}
              />
              <h1 style={{ borderBottom: "1px solid #aaa", margin: 0 }}>
                Pages
              </h1>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  marginTop: "15px",
                  flex: "0 0 auto"
                }}
              >
                {pages.sort(pageComparator).map((page, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        flex: `0 0 calc(${pageWidth}% - ${pageMargin * 2}px`,
                        marginLeft: `${pageMargin}px`,
                        marginRight: `${pageMargin}px`,
                        textAlign: "center"
                      }}
                    >
                      <b style={{ color: "#555" }}>Server-side preview</b>
                      <Page page={page} pageNumber={index} safeMode={true} />
                    </div>
                  );
                })}
              </div>
              <DuplicateModal
                userMessage={this.state.messageDuplicating}
                onMessageDuplicationComplete={this.onMessageDuplicationComplete}
                onClose={this.onCloseModal}
              />
              <ApproveModal
                userMessage={this.state.messageApproving}
                onClose={this.onCloseModal}
              />
              <ExpireModal
                userMessage={this.state.messageExpiring}
                onClose={this.onCloseModal}
              />
              <ExtendExpiryModal
                userMessage={this.state.messageExtending}
                onClose={this.onCloseModal}
              />
            </div>
          ) : (
            <div>Loading...</div>
          )}
        </section>
      </div>
    );
  }
}

const userMessageQuery = graphql(
  gql`
    query userMessageDetails($id: ID!) {
      user_messages(id: $id) {
        id
        title
        description
        created_at
        updated_at
        expires_at
        user_targeting_type
        version
        deeplink_action
        external_action
        icon
        user_message_pages {
          id
          body
          safe_mobile_html
          image
        }
      }
    }
  `,
  {
    options(props: any) {
      return {
        variables: {
          id: props.match.params.id
        }
      };
    }
  }
);

const bumpUserMessageVersion = graphql(
  gql`
    mutation bumpUserMessageVersion($id: ID!) {
      bump_user_message_version(id: $id) {
        id
      }
    }
  `,
  { name: "bumpUserMessageVersion" }
);

export default compose<any>(
  userMessageQuery,
  bumpUserMessageVersion
)(Summary);
